function isAgentTopUpPassengerTransaction (transaction) {
  if (!transaction || transaction.logType !== 'purchased_credit') return false
  return Boolean(transaction.transactionLogReferenceId)
}

module.exports = {
  isAgentTopUpPassengerTransaction
}
